"use client";

import { createElement, type ReactNode } from "react";
import {
  AdminOfflineBanner,
  installAdminOfflineStatus,
  readAdminOnlineStatus,
  type AdminOfflineNavigatorLike,
  type AdminOfflineStatus,
  type AdminOfflineWindowLike,
} from "@zzk/admin";

export {
  installAdminOfflineStatus,
  readAdminOnlineStatus,
  type AdminOfflineNavigatorLike,
  type AdminOfflineStatus,
  type AdminOfflineWindowLike,
};

export interface OfflineDetectorProps {
  readonly children?: ReactNode;
  readonly window?: AdminOfflineWindowLike | null;
  readonly navigator?: AdminOfflineNavigatorLike | null;
}

export function OfflineDetector({
  children,
  window,
  navigator,
}: OfflineDetectorProps) {
  return createElement(
    AdminOfflineBanner,
    {
      window,
      navigator,
    },
    children,
  );
}
